import React, { useEffect, useRef } from "react";

export const viewports: Set<HTMLCanvasElement> = new Set();

interface IViewportProps
{
	className?: string;
	width: number;
	height: number;
}

const Viewport = React.forwardRef<HTMLCanvasElement, IViewportProps>((props, ref) => 
{
	const canvasRef = useRef<HTMLCanvasElement | null>();
	const observer = useRef<IntersectionObserver>();

	const combineRefs = (element: HTMLCanvasElement | null) =>
	{
		canvasRef.current = element;

		if(typeof ref === "function")
		{
			ref(element);
		}
		else if(ref)
		{
			ref.current = element;
		}
	};

	useEffect(() => 
	{
		if(canvasRef.current)
		{
			observer.current = new IntersectionObserver((entries) => 
			{
				entries.forEach(entry => 
				{
					if (entry.isIntersecting) 
					{
						//observed element is visible
						viewports.add(canvasRef.current!);
					}
					else 
					{
						//observed element is not visible
						viewports.delete(canvasRef.current!);
					}
				});
			}, { threshold: 0 }); // Threshold 0 means that as soon as even one pixel is visible, the callback will be called
		
			observer.current.observe(canvasRef.current);
		}

		return () => 
		{
			if(observer.current)
			{
				observer.current.disconnect();
			}
			if(canvasRef.current)
			{
				viewports.delete(canvasRef.current);
			}
		};
	}, []);

	return (
		<canvas ref={combineRefs}
			className={["viewportCanvas", props.className].join(" ")}
			data-name={"viewport" + (props["data-name"] ? "-" + props["data-name"] : "")}
			data-viewport={true}
			width={props.width}
			height={props.height}			
		/>
	);
});

export default Viewport;